'use strict';

import angular from 'angular';

function MemTypeResource($resource) {
  return $resource('/api/groups/:groupId/membertypes/:id/:controller', {
    id: '@id'
  }, {
    getDefinedFor: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST',
      url: '/api/groups/:groupId/membertypes'
    },
    update: { method: 'PUT' }
  });
}

MemTypeResource.$inject = ['$resource'];

export default angular.module('georgeApp.memTypeSvc', [])
  .factory('MemTypeSvc', MemTypeResource)
  .name;
